import axiosConfig from './axios_config'

export const checkLicense = () => {
        return axiosConfig.post('/license/info')
}

export const setLicense = (obj: any) => {
        return axiosConfig.post(`license/set/${obj.serial}`)
}

export const getWifiList = () => {
        return axiosConfig.post('network/wifi/scan')
}

export const connectToWifi = (obj: any) => {
        return axiosConfig.post('network/wifi/connect', obj).catch(function (error) {
             return JSON.parse('{ "success": false }')
        })
}

export const connectToWired = (obj: any) => {
        return axiosConfig.post('network/wired/connect', obj)
}

export const driveInfo = () => {
        return axiosConfig.post('drive/info')
}

export const mount = (obj: object) => {
        return axiosConfig.post('drive/mount', obj)
}

export const unmount = (obj: object) => {
        return axiosConfig.post('drive/unmount', obj)
}

export const getYaraRules = () => {
        return axiosConfig.post('avs/yara/list')
}

export const deleteYaraRule = (obj: any) => {
        return axiosConfig.post(`avs/yara/delete/${obj.rule_name}`, obj)
}

export const addYaraRule = (obj: object) => {
        return axiosConfig.post('avs/yara/add', obj)
}

export const turnOff = () => {
        return axiosConfig.post('admin/shutdown')
}

export const reboot = () => {
        return axiosConfig.post('admin/reboot')
}

export const getAvList = () => {
        return axiosConfig.post('avs/list')
}

export const startUpdateAv = (obj: any) => {
        return axiosConfig.post(`avs/update/start/${obj.av_name}`, obj.data)
}

export const updateAvStatus = (obj: any) => {
        return axiosConfig.post(`avs/update/status/${obj.av_name}`)
}

export const setAvActive = (obj: any) => {
        return axiosConfig.post(`avs/enable/${obj.av_name}`)
}

export const setAvDeActive = (obj: any) => {
        return axiosConfig.post(`avs/disable/${obj.av_name}`)
}

export const stopAvUpdate = (obj: any) => {
        return axiosConfig.post(`avs/update/stop/${obj.av_name}`)
}

export const resumeAvUpdate = (obj: any) => {
        return axiosConfig.post(`avs/update/stop/${obj.av_name}`)
}

export const addFile = (obj: object) => {
        return axiosConfig.post('filemanager/add', obj)
}

export const showFileContent = (obj: any) => {
        return axiosConfig.post('filemanager/subitems', obj)
}

export const runDocker = (obj: any) => {
        return axiosConfig.post(`docker/start/${obj.av_name}`)
}

export const stopDocker = (obj: any) => {
        return axiosConfig.post(`docker/stop/${obj.av_name}`)
}

export const initScan = (obj: any) => {
        return axiosConfig.post(`scan/init`, obj)
}

export const startScan = (obj: any) => {
        return axiosConfig.post(`scan/start/${obj.guid}`)
}

export const scanResult = (obj: any) => {
        return axiosConfig.post(`scan/result/${obj.guid}`)
}

export const removeMalware = (obj: any) => {
        return axiosConfig.post(`scan/malware/remove/${obj.guid}`, obj.data)
} 

export const productDetails = () => {
        return axiosConfig.post('product/details')
} 

export const updateAvsList = () => {
        return axiosConfig.post('avs/list/update')
} 

export const downloadPDF = (obj: any) => {
        return axiosConfig.post(`scan/result/export/pdf/${obj.guid}`)
}

export const downloadHTML = (obj: any) => {
        return axiosConfig.post(`scan/result/export/html/${obj.guid}`)
}

export const scanStop = (obj: any) => {
        return axiosConfig.post(`scan/stop/${obj.guid}`)
}
